import { formatThousands } from '@mi-front/core';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { Chip, Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';
import { youtubeNativeRecentTransmissionsMessages } from '../recent/youtube-broadcasts.messages';

interface YoutubeBroadcastPeakViewersProps {
  peakViewers: number | null | undefined;
}

function formatPeakViewers(count: number): string {
  if (count >= 1000) {
    return `${Number((count / 1000).toFixed())}k`;
  }
  return String(count);
}

/** Icon chip with tooltip showing peak concurrent viewers for a YouTube broadcast. */
export function YoutubeBroadcastPeakViewers({ peakViewers }: YoutubeBroadcastPeakViewersProps) {
  const { formatMessage } = useIntl();

  if (peakViewers == null) {
    return null;
  }

  const tooltip = formatMessage(youtubeNativeRecentTransmissionsMessages.peakViewersTooltip, {
    count: formatThousands(peakViewers),
  });

  return (
    <Tooltip title={tooltip} placement="top">
      <Chip
        size="small"
        icon={<TrendingUpIcon fontSize="small" />}
        label={formatPeakViewers(peakViewers)}
        color="success"
        variant="outlined"
        sx={{
          cursor: 'default',
        }}
      />
    </Tooltip>
  );
}
